<template>
  <div></div>
</template>

<script>
import auth0 from "auth0-js";

import {
  AUTH0_CLIENT_ID,
  AUTH0_CLIENT_DOMAIN,
  AUTH0_CALLBACK,
  AUTH0_AUDIENCE,
} from "@/common/config";

export default {
  name: "Login",
  async mounted() {
    const auth0Obj = new auth0.WebAuth({
      domain: AUTH0_CLIENT_DOMAIN,
      clientID: AUTH0_CLIENT_ID,
    });
    await auth0Obj.authorize({
      audience: AUTH0_AUDIENCE,
      scope: "openid email",
      responseType: "token id_token",
      connection: this.$route.query.connection,
      redirectUri: AUTH0_CALLBACK,
    });
  },
};
</script>

<style scoped></style>
